import React, { useState, useEffect } from 'react';
import { Box, Button, Flex, Text } from '@chakra-ui/react';
import { AddIcon } from '@chakra-ui/icons';
import CategoryTree from '../components/CategoryTree';
import CategoryModals from '../components/CategoryModals';
import api from '../api';

const CategoriesPage = () => {
  const [categories, setCategories] = useState([]);
  const [expandedCategories, setExpandedCategories] = useState({});
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [formData, setFormData] = useState({ name: '', parent: '' });

  // Fetch categories from the API
  const fetchCategories = async () => {
    try {
      const response = await api.get('/categories/hierarchy/');
      setCategories(response.data);
    } catch (error) {
      console.error('Failed to fetch categories:', error);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  // Toggle the expanded/collapsed state of a category
  const toggleCategory = (id) => {
    setExpandedCategories((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const handleCreate = async () => {
    try {
      const payload = { name: formData.name };
      if (formData.parent) payload.parent = formData.parent;

      await api.post('/categories/', payload);
      fetchCategories();
      setIsCreateModalOpen(false);
    } catch (error) {
      console.error('Failed to create category:', error);
    }
  };

  const handleEdit = async () => {
    try {
      const payload = { name: formData.name };
      if (formData.parent) payload.parent = formData.parent;

      await api.put(`/categories/${selectedCategory.id}/`, payload);
      fetchCategories();
      setIsEditModalOpen(false);
    } catch (error) {
      console.error('Failed to edit category:', error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await api.delete(`/categories/${id}/`);
      fetchCategories();
    } catch (error) {
      console.error('Failed to delete category:', error);
    }
  };

  const handleCloseCreate = () => {
    setFormData({ name: '', parent: '' }); // Clear form data
    setIsCreateModalOpen(false);
  };
  
  const handleCloseEdit = () => {
    setFormData({ name: '', parent: '' }); // Clear form data
    setSelectedCategory(null); // Reset selected category
  };

  return (
    <Box p="6">
      <Flex justify="space-between" align="center" mb="6">
        <Text fontSize="2xl" fontWeight="bold">Категорії</Text>
        <Button leftIcon={<AddIcon />} colorScheme="blue" onClick={() => setIsCreateModalOpen(true)}>
          Додати категорію
        </Button>
      </Flex>

      {/* Category Tree */}
      <CategoryTree
        categories={categories}
        expandedCategories={expandedCategories}
        toggleCategory={toggleCategory}
        onEdit={(category) => {
          setSelectedCategory(category);
          setFormData({ name: category.name, parent: category.parent || '' });
          setIsEditModalOpen(true);
        }}
        onDelete={handleDelete}
      />

      {/* Modals */}
      <CategoryModals
        isCreateModalOpen={isCreateModalOpen}
        isEditModalOpen={!!selectedCategory}
        onCloseCreate={handleCloseCreate}
        onCloseEdit={handleCloseEdit}
        onSubmitCreate={handleCreate}
        onSubmitEdit={handleEdit}
        categories={categories}
        formData={formData}
        setFormData={setFormData}
      />
    </Box>
  );
};

export default CategoriesPage;
